// eslint-disable-next-line import/prefer-default-export
const isToday = date => {
  const today = new Date();
  const dateToCheck = typeof date === 'string' ? new Date(date) : date;
  return (
    dateToCheck.getDate() === today.getDate() &&
    dateToCheck.getMonth() === today.getMonth() &&
    dateToCheck.getFullYear() === today.getFullYear()
  );
};

const isDateInPast = date => (!date ? true : new Date(date) < new Date());

const msToMin = ms => ms / 1000 / 60;
const prefixWithZero = num => (num < 10 ? `0${num}` : `${num}`);

// Convert -9000000 to -02:30
const refactorOffsetToUTCCOde = offsetInMs => {
  const isNegative = offsetInMs < 0;
  const positiveOffsetInMs = isNegative ? offsetInMs * -1 : offsetInMs;
  const positiveOffsetInMin = msToMin(positiveOffsetInMs);
  const hours = Math.floor(positiveOffsetInMin / 60);
  const minutes = positiveOffsetInMin % 60;

  return `${isNegative ? '-' : '+'}${prefixWithZero(hours)}:${prefixWithZero(
    minutes,
  )}`;
};

export { isToday, isDateInPast, refactorOffsetToUTCCOde };
